import { useSearchParams } from 'react-router-dom';
import { useParams } from 'src/routes/hooks';
import TeamInviteView from 'src/sections/team-invite/view';

export default function TeamInvitePage() {
  // hooks
  const params = useParams();
  const [searchParams] = useSearchParams();

  const { orgId, userId } = params;
  const token = searchParams.get('token');

  return <TeamInviteView orgId={orgId} userId={userId} token={token} />;
}
